import axios from 'axios';
import { URL } from '../constants/index';

export const api = axios.create({
  baseURL: URL.base
});

export const apiMi4uVideoCall = axios.create({
  baseURL: URL.apiCallMi4u
});

export const apiNeuronMeetCall = axios.create({
  baseURL: URL.apiCallNeuronMeet
});

export const apiAudio = axios.create({
  baseURL: URL.apiAudio
});

export const apiAdmin = axios.create({
  baseURL: URL.apiAdmin
});

export const apiCopilot4u = axios.create({
  baseURL: URL.apiCopilot4u,
  headers: {
    'permission-token': 'oQMDXk8dK64yE75XtnV9YhRCp',
  }
});

